<template>
  <v-row>
    <v-col class="pt-1 pb-1">
      <v-menu ref="menuDesde" v-model="menuDesde" :close-on-content-click="false" transition="scale-transition" min-width="290px" :disabled="mode === 'show'" offset-y>
        <template v-slot:activator="{ on }">
          <validation-provider v-slot="{ errors }" name="valido desde" rules="required">
            <v-text-field v-model="fechaDesde" prepend-inner-icon="mdi-calendar-outline" color="gold" :error-messages="errors" label="Valido desde" readonly v-on="on" />
          </validation-provider>
        </template>
        <v-date-picker v-model="fechaDesde" :allowed-dates="setFechasPermitidas" :picker-date.sync="dateMayor" color="gold" landscape scrollable no-title locale="es-419" @input="menuDesde = false" />
      </v-menu>
    </v-col>
    <v-col class="pt-1 pb-1">
      <v-menu ref="menuHasta" v-model="menuHasta" :close-on-content-click="false" transition="scale-transition" min-width="290px" :disabled="mode === 'show'" offset-y>
        <template v-slot:activator="{ on }">
          <validation-provider v-slot="{ errors }" name="valido hasta" rules="required">
            <v-text-field v-model="fechaHasta" prepend-inner-icon="mdi-calendar-outline" color="gold" :error-messages="errors" label="Valido hasta" readonly v-on="on" />
          </validation-provider>
        </template>
        <v-date-picker v-model="fechaHasta" color="gold" :allowed-dates="setFechasPermitidas" :min="fechaMinHasta" :picker-date.sync="posicionarEN" landscape scrollable no-title locale="es-419" @input="menuHasta = false" />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    name: 'RangoFechas',
    props: {
      inFechaDesde: {
        type: String,
        required: false,
        default: null,
      },
      inFechaHasta: {
        type: String,
        required: false,
        default: null,
      },
      tipoContrato: {
        type: Object,
        required: false,
        default: null,
      },
      jugador: {
        type: Object,
        required: false,
        default: null,
      },
      contratoPadre: {
        type: Object,
        required: false,
        default: null,
      },
      mode: {
        type: String,
        required: false,
        default: null,
      },
    },
    data () {
      return {
        fechaDesde: this.inFechaDesde,
        fechaHasta: this.inFechaHasta,
        menuDesde: false,
        menuHasta: false,
        rangosFechasPermitido: [],
        fechaMinHasta: '',
        invertirRangoFechas: false,
        dateMayor: '',
        posicionarEN: '',
      }
    },
    watch: {
      contratoPadre (val) {
        // this.fechaHasta = ''
        // this.fechaDesde = ''
        if (val !== null) {
          this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_rango_padre/' + val.id })
            .then(response => {
              this.rangosFechasPermitido = response
              this.buscarFechaMayor(this.rangosFechasPermitido)
            })
        }
      },
      tipoContrato (val) {
        this.rangosFechasPermitido = []
        this.fechaHasta = ''
        this.fechaDesde = ''
        if (!val.superpone_vigencia_sn) {
          if (val.es_prestamo_sn) {
            this.invertirRangoFechas = true
          } else {
            this.getContratosXTipo()
            this.invertirRangoFechas = false
          }
        }
      },
      fechaDesde (val) {
        this.fechaMinHasta = val
        this.posicionarEN = val
        this.$emit('fDesdeChange', val)
      },
      fechaHasta (val) {
        this.$emit('fHastaChange', val)
      },
      inFechaDesde (val) {
        this.fechaDesde = val
      },
      inFechaHasta (val) {
        this.fechaHasta = val
      },
    },
    methods: {
      setFechasPermitidas (val) {
        let permitida = true
        for (var i = 0; i < this.rangosFechasPermitido.length; i++) {
          if (val > this.rangosFechasPermitido[i].valido_desde && val < this.rangosFechasPermitido[i].valido_hasta) {
            permitida = false
          } else {
            permitida = true
          }
        }
        if (this.contratoPadre !== null && this.invertirRangoFechas) {
          if (val < this.contratoPadre.valido_desde || val > this.contratoPadre.valido_hasta) {
            permitida = false
          }
        }
        return permitida
      },
      buscarFechaMayor (rangos) {
        this.dateMayor = dayjs().format('YYYY-MM-DD')
        if (rangos.length !== 0) {
          for (var i = 0; i < rangos.length; i++) {
            if (rangos[i].valido_hasta > this.dateMayor) {
              this.dateMayor = rangos[i].valido_hasta
            }
          }
        } else if (this.contratoPadre !== null) {
          this.dateMayor = this.contratoPadre.valido_desde
        }
        this.dateMayor = dayjs(this.dateMayor)
        this.dateMayor = this.dateMayor.add(1, 'days').format('YYYY-MM-DD')
      },
      getContratosXTipo: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/contrato_rango_superpone/' + this.tipoContrato.id + '/jugador/' + this.jugador.id })
          .then(response => {
            this.rangosFechasPermitido = response
            this.buscarFechaMayor(this.rangosFechasPermitido)
          })
      },
    },
  }
</script>
